/** Run optional work after page assets load and the browser has time to spare. */
export function afterPageLoad(callback: () => void): () => void {
  let cancelled = false;
  let idle: number | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const run = () => {
    if (!cancelled) callback();
  };
  const schedule = () => {
    if ("requestIdleCallback" in window) {
      idle = window.requestIdleCallback(run, { timeout: 5000 });
    } else {
      timer = setTimeout(run, 1000);
    }
  };
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
  return () => {
    cancelled = true;
    window.removeEventListener("load", schedule);
    if (idle !== undefined) window.cancelIdleCallback(idle);
    if (timer !== undefined) clearTimeout(timer);
  };
}
